(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-instagram-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-instagram-fields')) {
    customElements.define('tt-instagram-fields', class extends HTMLElement {
      connectedCallback() {
        this.closest('form').noValidate = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tt-pet-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tt-pet-fields')) {
    customElements.define('tt-pet-fields', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.closest('form');
        this.form.noValidate = false;
        this.form.enctype = 'multipart/form-data';
        this.file = this.querySelector('input[type="file"]');
        this.preview = this.querySelector('img');
        this.status = this.querySelector('[role="status"]');
        this.file.addEventListener('change', () => {
          if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
          this.preview.hidden = true;
          this.preview.removeAttribute('src');
          this.file.setCustomValidity('');
          this.status.textContent = '';
          const file = this.file.files[0];
          if (!file) return;
          if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
            this.file.setCustomValidity(this.dataset.fileError);
            this.status.textContent = this.dataset.fileError;
            this.file.reportValidity();
            return;
          }
          this.previewUrl = URL.createObjectURL(file);
          this.preview.src = this.previewUrl;
          this.preview.hidden = false;
          this.status.textContent = this.dataset.selected;
        });
        this.querySelectorAll('input[type="text"]').forEach(input => {
          input.addEventListener('input', () => input.setCustomValidity(input.required && !input.value.trim() ? this.querySelector('.tt-pet-fields__hint').textContent : ''));
        });
      }
      disconnectedCallback() {
        if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
